import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// init app
Rails.start()
Turbolinks.start()
ActiveStorage.start()

import Vue from 'vue/dist/vue.esm'
import VueSlickCarousel from 'vue-slick-carousel';
import MainBanner from './components/web/MainBanner';
import ProductDetailSlider from './components/web/ProductDetailSlider';
import RegencyFields from './components/web/RegencyFields';
import BidAmount from './components/web/BidAmount';
import CheckoutForm from './components/web/CheckoutForm';
import ProductType from './components/web/ProductType';
import InputPhoto from './components/web/InputPhoto';
import MoneyField from './components/web/MoneyField';
import VueCurrencyFilter from 'vue-currency-filter';
import CreateProductStep4 from './components/web/CreateProductStep4';
import VueCountdown from '@chenfengyuan/vue-countdown'
import moment from 'moment';
require('moment-countdown');

Vue.component('main-banner', MainBanner);
Vue.component('vue-slick-carousel', VueSlickCarousel);
Vue.component('product-detail-slider', ProductDetailSlider);
Vue.component('regency-fields', RegencyFields);
Vue.component('bid-amount', BidAmount);
Vue.component('checkout-form', CheckoutForm);
Vue.component('product-type', ProductType);
Vue.component('input-photo', InputPhoto);
Vue.component('money-field', MoneyField);
Vue.component('create-product-step-4', CreateProductStep4);
Vue.component('vue-countdown', VueCountdown)

Vue.use(VueCurrencyFilter,
{
  symbol : 'Rp',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
  avoidEmptyDecimals: undefined,
})

document.addEventListener('turbolinks:load', () => {
  /* eslint-disable no-unused-vars */
  new Vue({
    el: '#app'
  });

  const actionBurgerNavigation = () => {
    const unionMenu = document.getElementById('unionMenu');
    const Sidebar = document.getElementById('Sidebar');
    if(unionMenu) {
      unionMenu.addEventListener('click', () => {
        Sidebar.classList.add('is-active');
      });
    }
  };

  const closeSidebarNavigation = () => {
    const SidebarBackground = document.getElementById('SidebarBackground');
    const sidebarUnionMenu = document.getElementById('sidebarUnionMenu');
    const Sidebar = document.getElementById('Sidebar');
    if (Sidebar) {
      SidebarBackground.addEventListener('click', () => {
        Sidebar.classList.remove('is-active');
      });
      sidebarUnionMenu.addEventListener('click', () => {
        Sidebar.classList.remove('is-active');
      });
    }
  };


  actionBurgerNavigation();
  closeSidebarNavigation();

  var realTimeDOMs = document.getElementsByClassName("real-time")
  if(realTimeDOMs) {
    moment.locale('id')
    setInterval((() => {
      realTimeDOMs.forEach((element) => {
        let target = element.dataset['target']
        let parsedTime = new Date(target)
        let enText = moment(parsedTime).countdown().toString();
        let idText = enText.replace('days', 'hari')
        idText = idText.replace('day', 'hari') 
        idText = idText.replace('hours', 'jam') 
        idText = idText.replace('hour', 'jam') 
        idText = idText.replace('minutes', 'menit') 
        idText = idText.replace('minute', 'menit') 
        idText = idText.replace('seconds', 'detik') 
        idText = idText.replace('second', 'detik') 
        element.innerHTML = idText
      })
    }), 1000);
  }
});

import 'bootstrap/dist/js/bootstrap';

